export default __webpack_public_path__ + "static/media/mon_256.0b286004.png";